module.exports = __webpack_public_path__ + "img/cp3-3.777e712f.jpg";